import script from "./FdProductComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FdProductComponent.vue?vue&type=script&setup=true&lang=js"

import "./FdProductComponent.vue?vue&type=style&index=0&id=e51d0688&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e51d0688"]])

export default __exports__